import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context-state/AuthContext';
import { PATH_DASHBOARD } from '../routes/paths';

export default function DashboardRedirect() {
    const { user } = useAuthContext();

    // If user is a promoter, redirect to promoter page
    if (user?.isPromoter) {
        return <Navigate to={PATH_DASHBOARD.promoter} replace />;
    }

    // Otherwise, redirect to main dashboard
    return <Navigate to={PATH_DASHBOARD.main} replace />;
} 